import { Search } from './search.js';

class HeaderSearchMobile extends Search {
    constructor(selector) {
        super(selector);
    }

    showSearch() {
        $('body').addClass('m-search');
        $(this.input).closest('.header-search').addClass('active');
    }

    hideSearch() {
        $('body').removeClass('m-search');
        $(this.input).closest('.header-search').removeClass('active');
    }
}

export const headerSearch = new HeaderSearchMobile('.js-header-search--m');
